import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ResourceHero = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 border-b border-zinc-100">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-zinc-950 uppercase tracking-tight leading-[0.9] mb-8">
            The exact tools I use to build digital products <span className="text-zinc-400">&amp; bypass paralysis.</span>
          </h1>
          
          <p className="text-lg text-zinc-500 mb-10 max-w-2xl mx-auto">
            Stop switching tools and start shipping. This is my curated "Creator Stack" for high-velocity production with an ADHD brain.
          </p>

          <div className="max-w-md mx-auto min-h-[300px]">
            {/* Unsichtbarer iFrame fängt den Sendfox-Redirect ab */}
            <iframe name="hidden_iframe" id="hidden_iframe" style={{ display: 'none' }}></iframe>

            {isSubmitted ? (
              <motion.div 
                initial={{ opacity: 0 }} 
                animate={{ opacity: 1 }} 
                className="p-6 bg-zinc-100 text-zinc-900 rounded-lg border border-zinc-200 font-bold"
              >
                Success. Check your inbox for the template.
              </motion.div>
            ) : (
              <form 
                method="post" 
                action="https://sendfox.com/form/1998yn/36gl24" 
                target="hidden_iframe"
                className="flex flex-col w-full gap-4 text-left" 
                onSubmit={() => setTimeout(() => setIsSubmitted(true), 250)}
              >
                {/* Hidden honeypot field to stop bots */}
                <div style={{ position: "absolute", left: "-5000px" }} aria-hidden="true">
                  <input type="text" name="a_password" tabIndex={-1} defaultValue="" autoComplete="off" />
                </div>

                <div className="flex gap-4">
                  <input 
                    type="text" 
                    placeholder="First Name" 
                    name="first_name" 
                    required 
                    className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black text-black"
                  />
                  <input 
                    type="text" 
                    placeholder="Last Name" 
                    name="last_name" 
                    required 
                    className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black text-black"
                  />
                </div>

                <input 
                  type="email" 
                  placeholder="Your email address" 
                  name="email" 
                  required 
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black text-black"
                />
                
                <label className="flex items-start gap-2 text-sm text-gray-600">
                  <input type="checkbox" name="gdpr" value="1" required className="mt-1" />
                  <span>I agree to receive email updates and promotions.</span>
                </label>

                <button 
                  type="submit" 
                  className="w-full px-6 py-3 bg-black text-white font-bold rounded-lg hover:bg-gray-800 transition-colors"
                >
                  Send me the free template
                </button>
              </form>
            )}
          </div>
          <p className="mt-4 text-xs text-zinc-400">
            Join 1,200+ creators getting weekly systems. No spam, ever.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ResourceHero;